import { Breadcrumb } from "./Breadcrumbs";

export enum BreadcrumbTemplateEnum {
    AccessReports,
    Admin,
    ClientAdministration,
    ClientLicenses,
    Data,
    InternalReports,
    ManageTemplates,
    MemberPopulations,
    NetworkAssessment,
    Operations,
    Overviews,
    Performance,
    ProviderSets,
    Tags,
    Targeting,
    Terminations,
    Tools,
    UserAdministration,
}

interface BreadcrumbTemplates {
    [key: string]: Breadcrumb[];
}

const adminTemplate = [{
    iconClass: "fa-cogs",
    link: "/admin/dashboard",
    text: "Admin",
}];

const dataTemplate = [{
    iconClass: "fa-database",
    text: "Data",
}];

export const breadcrumbTemplates: BreadcrumbTemplates = {
    [BreadcrumbTemplateEnum.AccessReports]: [{
        link: "/access-reports",
        text: "Access Reports",
    }],
    [BreadcrumbTemplateEnum.Admin]: adminTemplate,
    [BreadcrumbTemplateEnum.ClientAdministration]: [
        ...adminTemplate,
        {
            link: "/admin/client-administration",
            text: "Client Administration",
        },
    ],
    [BreadcrumbTemplateEnum.ClientLicenses]: [
        ...adminTemplate,
        {
            iconClass: "fa-files-o",
            link: "/admin/client-license/manager",
            text: "Client Licenses",
        },
    ],
    [BreadcrumbTemplateEnum.Data]: dataTemplate,
    [BreadcrumbTemplateEnum.InternalReports]: [
        ...adminTemplate,
        {
            iconClass: "fa-files-o",
            link: "/admin/internal-reports",
            text: "Internal Reports",
        },
    ],
    [BreadcrumbTemplateEnum.ManageTemplates]: [
        ...adminTemplate,
        {
            iconClass: "fa-folder",
            link: "/admin/manage-templates",
            text: "Manage Templates",
        }
    ],
    [BreadcrumbTemplateEnum.MemberPopulations]: [
        ...dataTemplate,
        {
            iconClass: "fa-users",
            link: "/member-populations",
            text: "Member Populations",
        },
    ],
    [BreadcrumbTemplateEnum.NetworkAssessment]: [{
        link: "/?Filter=NetworkAssessment",
        text: "Network Assessment",
    }],
    [BreadcrumbTemplateEnum.Operations]: [{
        iconClass: "fa-cogs",
        link: "/operations/dashboard",
        text: "Operations",
    }],
    [BreadcrumbTemplateEnum.Overviews]: [{
        text: "Overviews",
    }],
    [BreadcrumbTemplateEnum.Performance]: [{
        iconClass: "fa-rocket",
        link: "/performance/dashboard",
        text: "Performance Dashboard",
    }],
    [BreadcrumbTemplateEnum.ProviderSets]: [
        ...dataTemplate,
        {
            iconClass: "fa-user-md",
            link: "/provider-sets/manager",
            text: "Providers",
        },
    ],
    [BreadcrumbTemplateEnum.Tags]: [{
        iconClass: "fa-tags",
        link: "/tags/view",
        text: "Tag Management",
    }],
    [BreadcrumbTemplateEnum.Targeting]: [{
        text: "Volume Targeting",
    }],
    [BreadcrumbTemplateEnum.Terminations]: [{
        text: "Volume Termination",
    }],
    [BreadcrumbTemplateEnum.Tools]: [{
        iconClass: "fa-wrench",
        text: "Tools",
    }],
    [BreadcrumbTemplateEnum.UserAdministration]: [
        ...adminTemplate,
        {
            iconClass: "fa-user",
            link: "/admin/user-administration",
            text: "User Administration",
        }
    ],
};
